import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomInput from '../Substitution/CustomPickDate';
import useIsMobile from '../../utils/useIsMobile';

const CustomDatePicker = ({ selected, onChange }) => {
    const isMobile = useIsMobile(768);

    return (
        <DatePicker
            className='datepicker'
            locale="ru"
            selected={selected}
            onChange={onChange}
            dateFormat="dd.MM.yyyy"
            customInput={isMobile ? <CustomInput /> : undefined}
            withPortal
        />
    );
};

export default CustomDatePicker;